module.exports = __webpack_public_path__ + "img/diagonal-bottom-right.0187710e.png";